<template>
  <div class="sms-opt-in-field-wrapper">
    <checkbox-input v-if="useCheckbox" v-show="checkboxVisible" :checkbox-id="calculatedInputId" :initial-value="value"
                    :input-name="calculatedInputName" :label="label" :show-label="showLabel" :validation-errors="validationErrors"
                    @change="checkboxChanged" @focus="$emit('focus')" />
    <template v-if="useHidden">
      <input type="hidden" :name="inputName" :value="value">
      <div class="mb-2 small-text">
        <span v-html="disclaimer" />
      </div>
    </template>

    <input type="hidden" :name="`${entityName}[sms_opt_in_type_id]`" :value="id">
  </div>
</template>

<script>
import CheckboxInput from './checkbox-input'
import WithInputIdAndName from '@/components/inputs/mixins/with-input-id-and-name'

export default {
  components: { CheckboxInput },

  mixins: [ WithInputIdAndName ],

  props: {
    entityName: {
      type: String,
      required: true
    },

    label: {
      type: String,
      required: false
    },

    phoneNumberPresent: {
      type: Boolean,
      required: true
    },

    showLabel: {
      type: Boolean,
      required: false,
      default: true
    },

    smsOptInTypeData: {
      type: Object,
      required: true
    },

    validationErrors: {
      type: Array,
      required: false
    }
  },

  emits: ['changed', 'focus'],

  data() {
    let initialValue = null
    if (this.smsOptInTypeData.modality === 'hidden') {
      initialValue = true
    } else if (this.smsOptInTypeData.hiddenUntilPhoneFilled) {
      initialValue = this.smsOptInTypeData.preChecked && this.phoneNumberPresent
    } else {
      initialValue = this.smsOptInTypeData.preChecked
    }

    return {
      disclaimer: this.smsOptInTypeData.disclaimer,
      fieldName: 'opt-in-sms',
      id: this.smsOptInTypeData.id,
      modality: this.smsOptInTypeData.modality,
      value: initialValue
    }
  },

  computed: {
    checkboxVisible() {
      if (this.smsOptInTypeData.hiddenUntilPhoneFilled) {
        return this.phoneNumberPresent
      } else {
        return true
      }
    },

    useCheckbox() {
      return this.modality === 'checkbox'
    },

    useHidden() {
      return this.modality === 'hidden'
    }
  },

  watch: {
    phoneNumberPresent() {
      if (this.smsOptInTypeData.hiddenUntilPhoneFilled) {
        // When the phone number becomes present, we need to update the value to true.
        // When the phone number is removed, we need to update the value to false.
        // Q: Why can't we just use a computed property for this?
        // A: Because we must _emit_ the updated value when it changes.
        this.value = this.phoneNumberPresent
        this.emitValue(true)
      }
    }
  },

  mounted() {
    // Need to emit so that if the user submits the form without checking/unchecking the box,
    // the parent component will have the correct values for these fields
    this.emitValue(true)
  },

  methods: {
    checkboxChanged(value) {
      this.value = value
      this.emitValue(false)
    },

    emitValue(automatedEvent) {
      this.$emit('changed', { smsOptInTypeId: this.id, optInSms: this.value, automatedEvent: automatedEvent })
    }
  }
}
</script>
